import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/clinic/(defaultLayout)/(detail)/detail/[id]/_components/Clinictabcontent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
